import { render, staticRenderFns } from "./GCCManage.vue?vue&type=template&id=0c899248&"
import script from "./GCCManage.vue?vue&type=script&lang=js&"
export * from "./GCCManage.vue?vue&type=script&lang=js&"
import style0 from "./GCCManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports